// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DoubleCard_wrapper__c9GFS","card":"DoubleCard_card__GAcXd","static":"DoubleCard_static__tTWBg"};